import React from 'react';

import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import { LoanFeesTestIds } from '../../../../LoanFees.testIds';

import AprIcon from './AprIcon';
import { iconStyles } from './AprIndicator.styles';

const AprIndicator = ({ isIncludedInApr = false }) => {
  if (!isIncludedInApr) {
    return null;
  }

  return (
    <Tooltip placement="top" title="This fee is included in the APR calculation">
      <IconButton
        disableRipple
        data-testid={LoanFeesTestIds.APR_INDICATOR_BUTTON}
        size="small"
        sx={iconStyles}
      >
        <AprIcon />
      </IconButton>
    </Tooltip>
  );
};

AprIndicator.propTypes = {
  isIncludedInApr: PropTypes.bool,
};

export default AprIndicator;
